import { Hotspot } from "@nova/protobuf"
import {
    entityValidator,
    enumValidator,
    idValidators,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
} from "../util"
import { isValidLonLat } from "@nova/calculate-geospatial"
import { HotspotStatus } from "@nova/constants"
import { dateAsNumber } from "../../util"

export const createHotspotValidator = entityValidator(Hotspot, {
    id: { validators: idValidators, nonNull: true },
    imageId: {
        validators: [
            // prototodo: link to image later
        ],
        nonNull: true,
    },
    longitude: {
        validators: longitudeValidators,
        nonNull: true,
    },
    latitude: {
        validators: latitudeValidators,
        nonNull: true,
    },
    confidence: {
        validators: [
            {
                validator: (confidence) => confidence > 0 && confidence <= 1,
                error: "Confidence is out of bounds",
            },
        ],
        nonNull: true,
    },
    polygon: {
        validators: [
            {
                validator: (polygon) => polygon.every(isValidLonLat),
                error: "Polygon contains invalid coordinates",
            },
        ],
        nonNull: true,
    },
})

export const updateHotspotValidator = entityValidator(Hotspot, {
    status: {
        validators: enumValidator("status", HotspotStatus),
        nonNull: true,
    },
})

export const getDefaultHotspotCreateArgs = () => ({
    createdAt: dateAsNumber(),
    status: HotspotStatus.Active,
    perimeter: [],
})

export type CreateHotspotArgs = UnionToTuple<keyof typeof createHotspotValidator>
export type UpdateHotspotArgs = UnionToTuple<keyof typeof updateHotspotValidator>
